import type { SceneContext } from '../_shared/types'
import type { NewsData } from './types'
import { newsIdx } from './tick'

export default function NewsBrief({ data, time }: SceneContext) {
  const d = data as unknown as NewsData
  const idx = newsIdx(data, time)
  const h = d.headlines?.[idx]
  if (!h) {
    return (
      <div className="pv-news" style={{ background: (data as any).bgColor }}>
        <div className="pv-news-end">End of briefing</div>
      </div>
    )
  }
  return (
    <div className="pv-news" style={{ background: (data as any).bgColor }}>
      <div className="pv-news-category">{d.category}</div>
      <div className="pv-news-card" style={{ borderLeft: `4px solid ${h.color}` }}>
        <div className="pv-news-source">
          <span className="pv-news-dot" style={{ background: h.color }} />
          {h.source} · {h.time}
        </div>
        <div className="pv-news-title">{h.title}</div>
      </div>
      <div className="pv-news-counter">
        {idx + 1} / {d.headlines.length}
      </div>
    </div>
  )
}
